<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="供应商名称">
      <el-input v-model="queryParam.name" placeholder="输入供应商名称" />
    </el-form-item>
    <!-- <el-form-item label="结算方式">
      <el-select v-model="queryParam.balanceway" placeholder="选择结算方式">
        <el-option label="日结" :value="1" />
        <el-option label="周结" :value="2" />
        <el-option label="半个月结" :value="3" />
        <el-option label="月结" :value="4" />
        <el-option label="季结" :value="5" />
        <el-option label="半年结" :value="6" />
        <el-option label="年结" :value="7" />
      </el-select>
    </el-form-item> -->
    <el-form-item label="有无合同">
      <el-select v-model="queryParam.iscontract" placeholder="选择有无合同">
        <el-option label="有" :value="1" />
        <el-option label="无" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item label="账期">
      <el-select v-model="queryParam.isaccount" placeholder="选择账期">
        <el-option label="日" :value="1" />
        <el-option label="周" :value="2" />
        <el-option label="月" :value="3" />
        <el-option label="半月" :value="4" />
        <el-option label="年结" :value="5" />
      </el-select>
    </el-form-item>
    <el-form-item label="开票税点">
      <el-input v-model="queryParam.taxpoint" placeholder="输入开票税点" />
    </el-form-item>
    <el-form-item label="状态">
      <el-select v-model="queryParam.status" placeholder="供应商状态">
        <el-option label="正常" :value="1" />
        <el-option label="停用" :value="2" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListSupplier">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="danger"
          @click="(dialog = true), doSupplierAdd()"
          v-hasPermission="['supplier:add']"
          >添加供应商</el-button
        >
        <el-button
          type="danger"
          @click="openImport('supplier:import')"
          v-hasPermission="['supplier:import']"
          >导入供应商</el-button
        >
        <el-button
          type="danger"
          :loading="loadingexport" @click="doExportSupplier"
          v-hasPermission="['supplier:export']"
          >{{loadingexport ? "处理中 ..." : "导出供应商"}}</el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table :data="tableData" v-loading="loadingData" class="mainTable" row-key="supplierid" height="600">
        <el-table-column label="供应商ID" prop="supplierid" width="250" />
        <el-table-column label="供应商" prop="name" width="250" />
        <el-table-column label="账期" prop="isaccount">
          <template #default="scope">
            <!-- :type="scope.row.isaccount === 1 ? 'success' : 'danger'" -->
            <el-tag
            v-if="scope.row.isaccount"
              round
              disable-transitions
              ><span v-text="util.supplierAccount(scope.row.isaccount)"></span>
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="结算方式" prop="balanceway">
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.balanceway === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showBalanceway(scope.row.balanceway)"></span>
            </el-tag>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="付款账户" prop="payaccount" width="200" /> -->
        <!-- <el-table-column label="可沟通授权" prop="isgrant"/> -->
        <el-table-column label="账期更新日期" prop="accounted" width="250"/>
        <el-table-column label="有无合同" prop="iscontract">
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.iscontract === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showYesNo(scope.row.iscontract)"></span>
            </el-tag>
          </template>
        </el-table-column>
       
        <el-table-column label="合同起止时间" prop="started" width="250">
          <template #default="scope">
          {{  scope.row.started }}至{{ scope.row.ended }}
          </template>
        </el-table-column>
        <el-table-column label="剩余天数" prop="contractday">
          <template #default="scope">
            {{ util.calculateDayDifference(now,scope.row.ended) }}
          </template>

        </el-table-column>
        <el-table-column label="更新日期" prop="changed" width="250">
          <template #default="scope">
            <span
              v-text="util.formatDateUnix(scope.row.changed, 'yyyy-MM-dd hh:mm')"
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" width="150">
          
          <template #default="scope">
            <el-tag
              round
              :type="scope.row.status === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showCommonStatus(scope.row.status)"></span>
            </el-tag>
            <el-switch
              :model-value="scope.row.status"
              v-hasPermission="['supplier:edit']"
              :active-value="1"
              :inactive-value="2"
              size="small"
              @change="doSupplierStatus(scope.$index, scope.row, 'status')"
            />
          </template>
          <!-- <template #default="scope">
        <el-tag
          round
          :type="scope.row.status === 1 ? 'success' : 'danger'"
          disable-transitions
          ><span v-text="util.showCommonStatus(scope.row.status)"></span>
        </el-tag>
      </template> -->
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="200">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doSupplierEdit(scope.$index, scope.row)"
              v-hasPermission="['supplier:edit']"
              >编辑</el-link
            >

            <el-link
              type="primary"
              size="small"
              @click="open('supplier:view', scope.row)"
              v-hasPermission="['supplier:view']"
              >查看</el-link
            >

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除吗？"
              width="200px"
              @confirm="doSupplierDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"
      ><div>
        <!-- <el-button
          type="danger"
          >添加用户</el-button> -->
      </div></el-col
    >
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="45%"
    @close="doSupplierClose"
  >
    <div class="common-drawer__content">
      <el-form
        ref="supplierFormRef"
        :model="supplierForm"
        :rules="rules"
        label-width="140px"
        autocomplete="off"
      >
        <el-form-item label="供应商名称" prop="name">
          <el-input
            v-model.trim="supplierForm.name"
            placeholder="请输入供应商名称"
          />
        </el-form-item>
        <!-- <el-form-item label="结算方式" prop="balanceway">
          <el-select
            v-model="supplierForm.balanceway"
            placeholder="选择结算方式"
            style="width: 100%"
          >
            <el-option label="日结" :value="1" />
            <el-option label="周结" :value="2" />
            <el-option label="半个月结" :value="3" />
            <el-option label="月结" :value="4" />
            <el-option label="季结" :value="5" />
            <el-option label="半年结" :value="6" />
            <el-option label="年结" :value="7" />
          </el-select>
        </el-form-item> -->

        <el-form-item label="付款方式" prop="payway">
          <el-select
            v-model="supplierForm.payway"
            placeholder="选择付款方式"
            style="width: 100%"
          >
            <el-option label="对公付款" :value="1" />
            <el-option label="对私付款" :value="2" />
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="付款账号" prop="payaccount">
          <el-input
            v-model.trim="supplierForm.payaccount"
            placeholder="请输入付款账号"
          />
        </el-form-item> -->

        <el-form-item label="有无合同" prop="iscontract">
          <el-select
            v-model="supplierForm.iscontract"
            placeholder="选择有无合同"
            style="width: 100%"
          >
            <el-option label="有" :value="1" />
            <el-option label="无" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="账期" prop="isaccount">
          <el-select
            v-model="supplierForm.isaccount"
            placeholder="选择账期"
            style="width: 100%"
          >
            <el-option label="日" :value="1" />
            <el-option label="周" :value="2" />
            <el-option label="月" :value="3" />
            <el-option label="半月" :value="4" />
            <el-option label="年结" :value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="开票类型" prop="taxtype">
          <el-select
            v-model="supplierForm.taxtype"
            placeholder="选择有开票类型"
            style="width: 100%"
          >
            <el-option label="增值税专用发票" :value="1" />
            <el-option label="增值税普通发票" :value="2" />
            <el-option label="不开票" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="开票税点" prop="taxpoint">
          <el-input
          autocomplete="off"
           v-model="supplierForm.taxpoint"
            placeholder="输入开票税点"
          />
        </el-form-item>
        <el-form-item label="账期更新日期" prop="accounted">
          <el-date-picker
            v-model="supplierForm.accounted"
            type="date"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            placeholder="选择账期更新日期"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="合同起止时间">
          <el-date-picker
            v-model="contractse"
            type="daterange"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @blur="changeContractse"
          />
        </el-form-item>
        <!-- <el-form-item label="合同起始时间" prop="started">
          <el-input
           v-model="supplierForm.started"
            placeholder="选择合同起始时间"
          />
        </el-form-item>
        <el-form-item label="合同结束时间" prop="ended">
          <el-input
           v-model="supplierForm.ended"
            placeholder="选择合同结束时间"
          />
        </el-form-item> -->
        <el-form-item label="合同到期剩余天数" prop="contractday">
          <el-input
           v-model="supplierForm.contractday"
            placeholder="输入合同到期剩余天数"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="supplierForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doSupplierClose">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doSupplierSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>
    
  <script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listSupplier, saveSupplier, exportSupplier, deleteSupplier } from "@/api/supplier";
import storage from  "@/util/storage";
import util from "@/util/tool.js";

const now = util.formatCurrentDate()

const router = useRouter();
let open = (routeName, row) => {
  storage.saveSessionObject("supplierPath",queryParam.value)
  router.push({
    name: routeName,
    params: { id: row.supplierid },
    // query: { name: row.name },
  });
};

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingexport = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const supplierFormRef = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

let title = ref("添加供应商");

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  balanceway: "",
  iscontract: "",
  isaccount: "",
  taxpoint: "",
  status: "",
});

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    taxpoint: "",
    status: "",
  };
  getListSupplier();
};

const supplierForm = ref({
  supplierid: null,
  name: "",
  balanceway: "",
  iscontract: "",
  isaccount: "",
  payway: "",
  payaccount: "",
  taxtype:"",
  taxpoint: "",
  accounted: "",
  started: "",
  ended: "",
  contractday: "",
  status: 1,
});

const tableData = ref([]);


let openImport = (routeName)=>{
  router.push({
    name: routeName
  });
}

let contractse = ref();
const changeContractse = () => {
  supplierForm.value.started = contractse.value[0]
  supplierForm.value.ended = contractse.value[1]

  supplierForm.value.contractday = util.calculateDayDifference(now,contractse.value[1])
};

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("supplierPath")
  if (query) {
    queryParam.value = query
  }
  getListSupplier();
});

const doSupplierAdd = () => {
  title.value = "新增供应商";
  resetForm();
};

const doSupplierEdit = (index, obj) => {
  title.value = "编辑供应商";
  // supplierForm.value = obj;//直接赋值会出问题

  supplierForm.value = {
    supplierid: obj.supplierid,
    name: obj.name,
    balanceway: obj.balanceway,
    iscontract: obj.iscontract,
    isaccount: obj.isaccount,
    payway: obj.payway,
    payaccount: obj.payaccount,
    taxtype: obj.taxtype,
    taxpoint: obj.taxpoint,
    accounted: obj.accounted,
    started: obj.started,
    ended: obj.ended,
    contractday: obj.contractday,
    status: obj.status,
  };
  contractse.value = [obj.started, obj.ended]
  
  supplierForm.value.contractday = util.calculateDayDifference(now, obj.ended)
};

const doSupplierClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  supplierFormRef.value.resetFields()
};

const resetForm = () => {
  supplierForm.value = {
    supplierid: null,
    name: "",
    balanceway: "",
    iscontract: "",
    isaccount: "",
    payway: "",
    payaccount: "",
    taxtype: "",
    taxpoint: "",
    accounted: "",
    started: "",
    ended: "",
    contractday: "",
    status: 1,
  };
  contractse.value = []
};

const doSupplierSave = () => {
  supplierFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    saveSupplier(supplierForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListSupplier();
          doSupplierClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//更新用户状态
const doSupplierStatus = (index, obj) => { 
  let status = obj.status == 1 ? 2 : 1;
  let data = { status,name:obj.name, supplierid: obj.supplierid.toString() };
  tableData.value[index].status = status;
  saveSupplier(data);
};


const doSupplierDelete = (index, obj) => {
  deleteSupplier(obj).then((res) => {
    if (res.data.code === 1) {
      getListSupplier();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListSupplier();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListSupplier();
};

//供应商表API
const getListSupplier = () => {
  storage.remove('supplierPath')
  listSupplier(queryParam.value).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false
  });
};


const doExportSupplier = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.pageSize = 5000
  loadingexport.value = true;
  exportSupplier(query).then((response) => {//queryParam.value
    downloadExcel(response);
  });
};

const downloadExcel = (response) => {
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingexport.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }, 1000);
};


//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 100,
      message: "名称长度2到100",
      trigger: "blur",
    },
  ],
  // balanceway: [
  //   {
  //     required: true,
  //     message: "请选择结算方式",
  //     trigger: "change",
  //   },
  // ],
  payway: [
    {
      required: true,
      message: "请选择付款方式",
      trigger: "change",
    },
  ],
  // payaccount: [
  //   {
  //     required: true,
  //     message: "请填写付款账号",
  //     trigger: "blur",
  //   },
  //   {
  //     min: 2,
  //     max: 100,
  //     message: "账号长度2到100",
  //     trigger: "blur",
  //   },
  // ],
  iscontract: [
    {
      required: true,
      message: "请选择有无合同",
      trigger: "change",
    },
  ],
  isaccount: [
    {
      required: true,
      message: "请选择账期",
      trigger: "change",
    },
  ],
  taxtype: [
    {
      required: true,
      message: "请选择开票类型",
      trigger: "change",
    },
  ],
  // taxpoint: [
  //   {
  //     required: true,
  //     // type: 'number',
  //     message: "请填写开票税点",
  //     trigger: "blur",
  //   },
  // ],
});
</script>